// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import mpfpayEntity from './entities/mpfpay.json';
import mpfpayMenu from '../pages/mpfpay/menu.json';
import mpfpayFullForm from '../pages/mpfpay/forms/full.json';
import mpfpayContextForm from '../pages/mpfpay/forms/context.json';
import mpfpayMiniForm from '../pages/mpfpay/forms/mini.json';
import mpfpayLookupForm from '../pages/mpfpay/forms/lookup.json';
import mpfpayTableView from '../pages/mpfpay/views/table.json';
import mpfpayStagesView from '../pages/mpfpay/views/stages.json';
import mpfpayCardsView from '../pages/mpfpay/views/cards.json';
import mpfpayInlineView from '../pages/mpfpay/views/inline.json';
import mpfpayBacklogView from '../pages/mpfpay/views/backlog.json';
import mpfpaySplitView from '../pages/mpfpay/views/split.json';
import mpfpayCalendarView from '../pages/mpfpay/views/calendar.json';
import mpfpayDashboardView from '../pages/mpfpay/views/dashboard.json';

/** Тип запису «Виплата помічнику» зі сторінками пакета: меню, форми та подання з pages/mpfpay/. */
export const mpfpayDefinition: IRecordTypeDefinition = {
  ...mpfpayEntity,
  views: assembleViewSet({
      table: mpfpayTableView,
      stages: mpfpayStagesView,
      cards: mpfpayCardsView,
      inline: mpfpayInlineView,
      backlog: mpfpayBacklogView,
      split: mpfpaySplitView,
      calendar: mpfpayCalendarView,
      dashboard: mpfpayDashboardView,
  }),
  form: mpfpayFullForm,
  forms: { full: mpfpayFullForm, context: mpfpayContextForm, mini: mpfpayMiniForm, lookup: mpfpayLookupForm },
  menu: mpfpayMenu,
} as IRecordTypeDefinition;
